import { t } from "@/i18n-js/instance";
import "./styles.scss";

interface FullScreenTabsProps {
  children: React.ReactNode;
}

export const FullScreenTabs = ({ children }: FullScreenTabsProps) => (
  <div className="react-layout-fullscreen-tabs">
    <div className="react-layout-fullscreen-wrapper">
      <nav aria-label={t("full_screen_layout.tabs")}>{children}</nav>
    </div>
  </div>
);
